




















import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

@Component
export default class Snackbar extends Vue {
  @Getter('snackbar/active') private snackbarActive!: boolean;
  @Getter('snackbar/color') private color!: string;
  @Getter('snackbar/message') private message!: string;
  @Action('snackbar/stop') private stop!: () => void;

  private y: string = 'top';
  private x: string = 'right';
  private timeout: number = 5000;

  get active() {
    return this.snackbarActive;
  }

  set active(active: boolean) {
    this.stop();
  }
}
